import { Injectable, inject } from '@angular/core';
import { environment } from '@rocksoft/environment';
import * as Sentry from '@sentry/angular';
import { LoggingService } from './logging.service';

// Error handler combining Application Insights and Sentry with environment-aware guards
@Injectable()
export class CombinedErrorHandler extends Sentry.SentryErrorHandler {
  private loggingService = inject(LoggingService);

  constructor() {
    super({ logErrors: false });
  }

  handleError(error: unknown): void {
    // Narrow unknown to Error where possible
    const err: Error = error instanceof Error ? error : new Error(typeof error === 'string' ? error : 'Unknown error');
    console.error('Error caught by CombinedErrorHandler:', err);

    // Application Insights (only if key present)
    if (environment.appInsights?.instrumentationKey) {
      try {
        this.loggingService.logException(err);
      } catch {
        // Intentionally empty - don't let AI logging failures break handler
      }
    }

    // Sentry (only if enabled)
    if (environment.sentry?.enabled) {
      try {
        super.handleError(err);
      } catch {
        // Intentionally empty - don't let Sentry failures break handler
      }
    }
  }
}
